import React, { useState } from 'react';
import { css } from 'emotion';
import { Link } from '@guardian/src-link';
import { Button } from '@guardian/src-button';
import { text } from '@guardian/src-foundations/palette';
import { textSans } from '@guardian/src-foundations/typography';
import { FileUpload } from './FileUpload';
import { MultiSelect } from './MultiSelect';
import { Select } from './Select';
import { TextArea } from './TextArea';
import { TextInput } from './TextInput';
const formStyles = css `
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding-left: 10px;
	padding-right: 10px;
`;
const footerPaddingStyles = css `
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding-bottom: 15px;
`;
const errorMessagesStyles = css `
	padding-bottom: 10px;
	color: ${text.error};
	${textSans.medium({ fontWeight: 'bold' })};
`;
const formFieldWrapperStyles = css `
	display: flex;
	flex-direction: column;
`;
const FormField = ({ formField, formData, setFormData }) => {
    switch (formField.type) {
        case 'textarea':
            return (React.createElement(React.Fragment, null,
                React.createElement(TextArea, { formField: formField, formData: formData, setFormData: setFormData }),
                React.createElement("hr", null)));
        case 'file':
            return (React.createElement(React.Fragment, null,
                React.createElement(FileUpload, { formField: formField, formData: formData, setFormData: setFormData }),
                React.createElement("hr", null)));
        case 'select':
            return (React.createElement(React.Fragment, null,
                React.createElement(Select, { formField: formField, formData: formData, setFormData: setFormData }),
                React.createElement("hr", null)));
        case 'checkbox':
        case 'radio':
            return (React.createElement(React.Fragment, null,
                React.createElement(MultiSelect, { formField: formField, formData: formData, setFormData: setFormData, multiple: formField.type === 'checkbox' }),
                React.createElement("hr", null)));
        default: {
            return (React.createElement(React.Fragment, null,
                React.createElement(TextInput, { formField: formField, formData: formData, setFormData: setFormData }),
                React.createElement("hr", null)));
        }
    }
};
export const Form = ({ onSubmit, formFields, error }) => {
    const [twitterHandle, setTwitterHandle] = useState('');
    const [formData, setFormData] = useState({});
    return (React.createElement("form", { action: "/formstack-campaign/submit", method: "post", className: formStyles, onSubmit: (e) => {
            e.preventDefault();
            onSubmit(formData);
        } },
        formFields.map((formField, index) => (React.createElement("div", { className: formFieldWrapperStyles, "custom-guardian": "callout-form-field", key: index },
            React.createElement(FormField, { formField: formField, formData: formData, setFormData: setFormData })))),
        React.createElement("div", { className: css `
					position: absolute;
					left: -62.5rem;
				`, "aria-hidden": "true" },
            React.createElement("input", { name: "twitter-handle", type: "text", id: "twitter-handle", tabIndex: -1, placeholder: "@mytwitterhandle", value: twitterHandle, onChange: (e) => setTwitterHandle(e.target.value) })),
        error && React.createElement("div", { className: errorMessagesStyles }, error),
        React.createElement("div", { className: footerPaddingStyles },
            React.createElement(Button, { priority: "secondary", size: "xsmall", type: "submit" }, "Share with the Guardian"),
            React.createElement("div", { className: css `
						a,
						a:hover {
							border: 0;
						}
						text-align: right;
					` },
                React.createElement(Link, { subdued: true, priority: "secondary", target: "_blank", href: "https://www.theguardian.com/help/terms-of-service" }, "Terms and conditions")))));
};
